export default {
  en: {
    translations: {
      common: {
        loading: 'Loading',
        loadMore: 'Load again',
        never: 'Never',
        filter: 'Filter',
        actions: 'Actions',
        successMessage: 'Successful operation',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        update: 'Update',
        download: 'Download',
        upload: 'Upload',
        detail: 'Details',
        add: 'Add',
        yes: 'Yes',
        no: 'No',
        sureToDelete: 'Sure to delete?',
        create: 'Create',
      },
      validations: {
        required: 'Required',
        fromTo: 'The start value must be less than the end value',
        notInList: 'Value not included in {{ items }}',
      },
      enums: {
        soundMeters: {
          inputGains: {
            GAIN_0dB: '0 dB',
            GAIN_10dB: '10 dB',
            GAIN_20dB: '20 dB',
            GAIN_30dB: '30 dB',
            GAIN_40dB: '40 dB',
          },
          noiseOrigins: {
            FF: 'FF',
            RI: 'RI',
          },
          windscreenCorrections: {
            OFF: 'OFF',
            SAV: 'SAV',
            WME: 'WME',
          },
          ponds: {
            A: 'A',
            C: 'C',
            Z: 'Z',
          },
          parameters: {
            LPK: 'Lpk',
            LPKMX: 'Lpkmx',
            LEQS: 'LeqS',
            LEQ: 'Leq',
            LFP: 'LFp',
            LSP: 'LSp',
            LIP: 'LIp',
            LFMX: 'LFmx',
            LSMX: 'LSmx',
            LIMX: 'LImx',
            LFMN: 'LFmn',
            LSMN: 'LSmn',
            LIMN: 'LImn',
            LE: 'LE',
            LEQI: 'LeqI',
            DOSE: 'DOSE',
            DOSE_D: 'DOSE D',
            LAV4: 'LAV4',
            LAV5: 'LAV5',
            LEP_D: 'LEP D',
            EA: 'EA',
            L1: 'L1',
            L2: 'L2',
            L3: 'L3',
            L4: 'L4',
            OL: 'OL',
            UR: 'UR',
          },
          spectreTypes: {
            AVERAGE: 'AVERAGE',
            MULTISPECTRE: 'MULTISPECTRE',
            MAXIMUM: 'MAXIMUM',
            MINIMUM: 'MINIMUM',
          },
          spectreMeans: {
            LINEAR: 'Linear',
            EXPONENTIAL: 'Exponential',
          },
          spectreMeanWeights: {
            SLOW: 'Slow',
            FAST: 'Fast',
          },
          thirdOctaveMeans: {
            LINEAR: 'Linear',
            EXPONENTIAL: 'Exponential',
          },
          thirdOctaveMeanWeights: {
            SLOW: 'Slow',
            FAST: 'Fast',
          },
          FFTBands: {
            HF: 'HF',
            MF: 'MF',
            LF: 'LF',
          },
          times: {
            TIME_0_125s: '0.125s',
            TIME_0_25s: '0.25s',
            TIME_0_5s: '0.5s',
            TIME_1s: '1s',
            TIME_2s: '2s',
            TIME_5s: '5s',
            TIME_10s: '10s',
            TIME_20s: '20s',
            TIME_30s: '30s',
            TIME_1m: '1m',
            TIME_2m: '2m',
            TIME_5m: '5m',
            TIME_10m: '10m',
            TIME_20m: '20m',
            TIME_30m: '30m',
            TIME_1h: '1h',
          },
        },
      },
      sideMenu: {
        devices: 'Remote devices',
        localSoundMeters: 'Local devices',
        noiseStudio: 'Noise Studio',
      },
      rightMenu: {
        editProfile: 'Edit profile',
        logout: 'Logout',
      },
      extractGraphQLErrors: {
        networkError: 'Server unreachable, check connection',
        unexpectedError: 'Unexpected error occurred',
      },
      breadcrumbs: {
        devices: 'Remote devices',
      },
      devices: {
        list: {
          title: 'Remote devices',
          subtitle: 'Remote Device List',
          table: {
            serialNumber: 'Serial number',
            typename: 'Type',
            name: 'Nome',
            lastOnline: 'Last connection',
            nextOnline: 'Next connection',
            active: 'Active',
            inMaintenance: 'Under Maintenance',
            activate: 'Activate',
            deactivate: 'Deactivate',
            maintenanceOn: 'Activate maintenance',
            maintenanceOff: 'Deactivate maintenance',
          },
        },
        components: {
          filter: {
            search: 'Search',
            active: 'Active',
          },
        },
      },
      h2090s: {
        components: {
          form: {
            name: 'Name',
          },
          updateWorkspaceForm: {
            workspaceId: 'Workspace',
          },
          changeUserForm: {
            email: 'Email',
          },
          disabledMonitor: {
            disableDescription: 'Monitor disabled',
            enableButton: 'Enable monitor',
          },
          enabledMonitor: {
            disableButton: 'Disable monitor',
          },
        },
        detail: {
          tabs: {
            general: 'General',
            updateWorkspace: 'Update workspace',
            user: 'Users',
            monitor: 'Monitor',
          },
        },
        updateWorkspaceTab: {
          title: 'Update workspace',
        },
        monitorTab: {
          title: 'Monitor',
        },
      },
      comboStations: {
        components: {
          form: {
            name: 'Name',
            timezone: 'Time zone',
          },
          changeUserForm: {
            email: 'Email',
          },
          currentConfigForm: {
            configId: 'Current configuration',
            workspaceId: 'Workspace',
          },
          configCreateModal: {
            title: 'Create new configuration',
          },
          configEditModal: {
            title: 'Edit configuration',
          },
          configForm: {
            general: {
              title: 'General and scheduling',
              name: 'Name',
              sleepTime: 'Sleep minutes',
              uploadCycle: 'Upload cycles',
              scheduleDivider: 'Scheduling',
              startDate: 'Start',
              endDate: 'End',
              continuous: 'Continuous recording',
              mondayTitle: 'Monday',
              tuesdayTitle: 'Tuesday',
              wednesdayTitle: 'Wednesday',
              thursdayTitle: 'Thursday',
              fridayTitle: 'Friday',
              saturdayTitle: 'Saturday',
              sundayTitle: 'Sunday',
              addSchedule: 'Add schedule',
            },
            soundMeter: {
              title: 'Device configuration',
              inputGain: 'Input gain',
              noiseOrigin: 'Noise origin',
              l1: 'L1',
              l2: 'L2',
              l3: 'L3',
              l4: 'L4',
              timeHistoryDivider: 'Time History',
              timeHistoryActive: 'Time history attivo',
              timeHistoryPond: 'Profile weighting',
              timeHistorySlmParameter: 'Parameter {{index}}',
              timeHistorySlmPond: 'Parameter weighting {{index}}',
              timeHistoryThirdOctaveActive: 'Third Octave active',
              timeHistoryThirdOctaveMean: 'Average',
              timeHistoryThirdOctaveMeanWeight: 'Average weighting',
              reportDivider: 'Report',
              reportActive: 'Report active',
              reportInterval: 'Interval',
              reportParameter: 'Parameter {{index}}',
              reportPond: 'Parameter weighting {{index}}',
              reportThirdOctave: 'Third Octave active',
              reportStatistics: 'Statistics',
            },
          },
        },
        detail: {
          tabs: {
            general: 'General',
            currentConfig: 'Current configuration',
            configs: 'Configurations',
            user: 'Users',
          },
        },
        generalTab: {
          title: 'General',
          lastMonitor: 'Last monitor {{date}}',
          lastStatus: 'Last status {{date}}',
        },
        currentConfigTab: {
          title: 'Current configuration',
        },
        userTab: {
          title: 'Users',
          userTitle: 'User',
          ownersTitle: 'Owners',
        },
        configsTab: {
          title: 'Configurations',
          table: {
            name: 'Name',
          },
        },
      },
      localSoundMeters: {
        connect: {
          title: 'Local Devices',
          subtitle: 'Local Devices management',
          infoTitle: 'Verify Local Devices',
          infoSubTitle: 'Connect the device via the USB port and use the button to verify your sound meter',
          connectButton: 'Verify',
          oldVersionsButton: 'Old versions',
          xpt800Button: 'XPT800',
          serial: 'Serial communication',
          serialUnavailable: 'Your browser does not support serial communication. Try using Chrome or Edge',
          cannotConnect: {
            title: 'Unable to communicate with the device',
            link: 'Make sure it is properly connected',
            port: 'Make sure the selected serial port is correct',
            model: 'Ensure that the model is supported',
            usb: 'Ensure that USB communication is enabled',
          },
        },
      },
      soundMeterHD2Series: {
        components: {
          configCreateModal: {
            title: 'Create new configuration',
          },
          configEditModal: {
            title: 'Edit configuration',
          },
          setConfigButton: {
            sendConfigError: 'Error while transferring configuration',
            modalTitle: 'Sending configuration',
          },
          configForm: {
            title: 'Sound Level Meter configuration',
            name: 'Name',
            inputGain: 'Input gain',
            noiseOrigin: 'Noise origin',
            windscreenCorrection: 'Windshield correction',
            overloadLevels: 'Overload levels',
            doseExchangeRate: 'Dose exchange rate',
            doseThreshold: 'Dose threshold',
            doseCriterion: 'Dose criterion',
            l1: 'L1',
            l2: 'L2',
            l3: 'L3',
            l4: 'L4',
            spectreDivider: 'Spectrum',
            spectreTime: 'Spectrum time',
            spectreType: 'Spectrum type',
            spectreMean: 'Spectrum average',
            spectreMeanWeight: 'Spectrum average weight',
            timeHistoryDivider: 'Time History',
            timeHistoryActive: 'Time history active',
            timeHistoryProfileParameter: 'Profile parameter',
            timeHistoryProfilePond: 'Profile weighting',
            timeHistoryProfileTime: 'Profilo time',
            timeHistorySlmParameter: 'Parameter {{index}}',
            timeHistorySlmPond: 'Parameter weighting {{index}}',
            timeHistoryOctave: 'Octave',
            timeHistoryThirdOctave: 'Third Octave',
            leqShort: 'LEQ short',
            FFTActive: 'FFT active',
            FFTBand: 'FFT',
            reportDivider: 'Report',
            reportActive: 'Report active',
            reportInterval: 'Interval',
            reportParameter: 'Parameter {{index}}',
            reportPond: 'Parameter weighting {{index}}',
            reportOctave: 'Octave',
            reportThirdOctave: 'Third Octave',
            reportStatistics: 'Statistics active',
            reportStatisticsParamenter: 'Statistical Parameter',
            reportStatisticsPond: 'Statistics weighting',
          },
        },
        manage: {
          title: 'Local Devices',
          subtitle: 'Local Devices management',
          infoTitle: 'Connect Local Devices',
          infoSubTitle: 'Connect the device via the USB port and use the Connect button',
          connectButton: 'Connect',
          serial: 'Serial communication',
          connecting: 'Connecting',
          tabs: {
            info: 'Info',
            configs: 'Configurations',
            download: 'Download',
          },
        },
        infoTab: {
          title: 'Info',
          serialNumberLabel: 'Serial',
          modelNumberLabel: 'Model',
          optionLabel: 'Option',
          classLabel: 'Class',
        },
        configsTab: {
          title: 'Configurations',
          table: {
            name: 'Name',
            setConfig: 'Send configuration',
          },
        },
        downloadTab: {
          title: 'Download',
          downloadFile: 'Download file',
          uploadNoiseStudio: 'Upload noise studio',
          fileName: 'File name',
          workspaceId: 'Workspace',
          timezone: 'Time zone',
          namePrefix: 'Session Name Prefix',
          uploadSuccess: 'Upload successfully completed',
          errors: {
            binAutoTimeoutOrInvalidMemoryFormat: 'Dump request timeout or incorrect memory format',
            noFilesFound: 'No files found',
          },
        },
      },
      soundMeterXPT800: {
        manage: {
          title: 'XPT800',
          subtitle: 'XPT800 local device management',
        },
        connect: {
          infoTitle: 'Connect XPT800',
          infoSubTitle: 'Connect the device via the USB port and use the button to verify your sound meter',
          connectButton: 'Connect',
          claimSuccess: 'Device successfully associated to your account',
          alreadyBound: {
            title: 'Device already associated',
            description: 'This sound meter is already bound to another user',
          },
        },
      },
    },
  },
};
